module.exports = __webpack_public_path__ + "static/media/whatsapp.5e95d9ab.png";